import React from 'react';
import './../../../Styles/Cart/PhoneNumberModel.css';
import Box from '@mui/material/Box';
import Modal from '@mui/material/Modal';
import CloseIcon from '../../../assets/svg/closeIcon';
import { useTranslation } from 'react-i18next';

function PhoneNumberModal({
    open,
    handleClose,
    phoneNumber,
    phoneError,
    handlePhoneChange,
    handleSubmitPhone
}) {
    const { t } = useTranslation();
    return (
        <Modal
            open={open}
            onClose={handleClose}
            aria-labelledby="phone-number-modal"
            style={{
                backdropFilter: 'blur(10px)',
                backgroundColor: '#2C3142B2 !important',
            }}
        >
            <Box className="phone-number-modal">
                <div className="phone-form-container">
                    <div className="phone-form-header">
                        <h1 className='phone-model-title'>{t('cart.add-phone-number')}</h1>
                        <CloseIcon
                            size={30}
                            color='black'
                            onClick={handleClose}
                            className='close-icon'
                        />
                    </div>
                    <div className="phone-input-container">
                        <input
                            type="tel"
                            placeholder={t('cart.enter-phone-placeholder')}
                            value={phoneNumber}
                            onChange={handlePhoneChange}
                            className="phone-input"
                            maxLength={10}
                        />
                        {phoneError && <p className="error-message">{phoneError}</p>}
                    </div>
                    <button
                        onClick={handleSubmitPhone}
                        className="submit-phone-btn"
                        disabled={!phoneNumber || phoneError}
                        style={{
                            cursor: (!phoneNumber || phoneError) ? 'not-allowed' : 'pointer',
                            opacity: (!phoneNumber || phoneError) ? 0.7 : 1,
                        }}
                    >
                        {t('cart.save-button')}
                    </button>
                </div>
            </Box>
        </Modal>
    );
}

export default PhoneNumberModal;
